import {Capacitor} from '@capacitor/core'
import {Device} from '@capacitor/device'
import {ActionPerformed, PushNotifications, Token} from '@capacitor/push-notifications'
import axios from 'axios'
import NotificationsService from '@src/services/notifications'
import {navigateToSession} from '@src/services/capacitorNavigation'
import {USER_DEVICE_ID_KEY} from '@src/stores/auth'

async function registerDeviceToken(token: string): Promise<void> {
    const info = await Device.getInfo()
    const deviceType = [info.manufacturer, info.model].filter(Boolean).join(' ')

    const response = await axios.post('/app/device/register', {
        device_token: token,
        device_type: deviceType,
    })

    const deviceId = response.data?.data?.id
    if (deviceId) {
        localStorage.setItem(USER_DEVICE_ID_KEY, String(deviceId))
    }
}

let listenersInitialized = false

export async function initPushNotifications(): Promise<void> {
    if (!Capacitor.isNativePlatform()) return

    const permission = await PushNotifications.requestPermissions()
    if (permission.receive !== 'granted') return

    if (!listenersInitialized) {
        listenersInitialized = true

        PushNotifications.addListener('registration', async (token: Token) => {
            try {
                await registerDeviceToken(token.value)
            } catch (e) {
                console.error('Erro ao registrar device token:', e)
            }
        })

        PushNotifications.addListener('registrationError', (err) => {
            console.error('Erro no registro de push:', err)
        })

        // Notificação recebida com app aberto — toca o som
        PushNotifications.addListener('pushNotificationReceived', (notification) => {
            const body = notification.body ?? ''
            NotificationsService.notify(body)
        })

        // Usuário tocou na notificação
        PushNotifications.addListener('pushNotificationActionPerformed', async (action: ActionPerformed) => {
            const data = action.notification.data
            if (data?.action === 'open-chat' && data?.session) {
                await navigateToSession(Number(data.session))
            }
        })
    }

    await PushNotifications.register()
}
